<template lang="pug">
.view-platform
  ui-navbar-panel.mb-20(backLink="platforms", backLinkText="К списку")
    template(slot="filters")
      span Платформа # {{ this.$route.params.id }} &nbsp;
      b {{ this.platform.name }}

    template
      b-button.is-primary(@click="save", icon-left="check", :disabled="!this.canEdit()") Сохранить

  .container(v-if="!platform.$state.loading")
    form-component(
      v-model="platform",
      form="edit-platform-form",
      ref="form",
      @afterSave="routeToPlatforms"
    )
</template>

<script>
import Platform from '@/models/Platform';
import BButton from 'buefy/src/components/button/Button';
import BField from 'buefy/src/components/field/Field';
import BIcon from 'buefy/src/components/icon/Icon';

import { mapGetters } from 'vuex';

export default {
  name: 'view-edit-platform',

  components: { BIcon, BField, BButton },

  data: () => ({
    platform: new Platform(),
  }),

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    $route() {
      this.loadState();
    },
  },

  methods: {
    canEdit() {
      return this.user.isAdmin;
    },

    save() {
      this.$refs.form.save();
    },

    loadState() {
      if (this.$route.params.id) {
        this.platform.id = +this.$route.params.id;
        this.platform.$find(+this.$route.params.id, {
          include: 'server',
        });
      }
    },

    routeToPlatforms() {
      this.$router.replace({ name: 'platforms' });
    },
  },

  created() {
    this.loadState();
  },
};
</script>
